import { render, staticRenderFns } from "./ElDrawer.vue?vue&type=template&id=b897b268&scoped=true&"
import script from "./ElDrawer.vue?vue&type=script&lang=ts&"
export * from "./ElDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./ElDrawer.vue?vue&type=style&index=0&id=b897b268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b897b268",
  null
  
)

export default component.exports